<template>
  <div class="form-group" v-show="isVisible">
      <ul id="tags-list" class="filter" data-type="tags">
          <li class="group-title">
              {{ title }}
          </li>
          <app-filter v-for="filter in filters"
                  :key="filter.Id"
                  :filter="filter">
          </app-filter>
      </ul>
  </div>
</template>
<script>
  import { store } from '../store.js';
  import filter from './filter.vue';

  export default {
      props: ['title', 'filters'],
      components: {
          'appFilter': filter
      },
      data: function () {
          return {
              state: store.state
          }
      },
      methods: {
          getFilterClass: function (filter) {
              var propertyName = 'filter' + filter.Level;
              var obj = {
                  propertyName: filter.Level != undefined
              };
              return obj;
          }
      },
      computed: {
          isVisible: function () {
              return this.filters.length > 0;
          }
      }
  }
</script>